import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, SkeletonLoader, useTooltip } from '@frontend/design-system';

export const ActionBarButton = ({
  iconName,
  title,
  label,
  isActive,
  trackingId,
  shouldHide = false,
  isLoading = false,
  onClick,
}: {
  iconName: IconName;
  title?: string;
  label: string;
  isActive?: boolean;
  trackingId?: string;
  shouldHide?: boolean;
  isLoading?: boolean;
  onClick: () => void;
}) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'right-end' });

  if (shouldHide) {
    return null;
  }

  return (
    <>
      {isLoading ? (
        <SkeletonLoader height={68} width={79} />
      ) : (
        <>
          <NakedButton
            {...triggerProps}
            onClick={onClick}
            trackingId={trackingId}
            css={css`
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              height: 68px;
              gap: ${theme.spacing(1)};
              padding: ${theme.spacing(1)} 0;
              width: 100%;
              color: ${isActive ? theme.colors.primary[50] : theme.colors.neutral70};
              background-color: ${isActive ? theme.colors.primary5 : theme.colors.white};
              transition: background-color 0.2s, color 0.2s, border 0.2s;
              cursor: pointer;
              :hover {
                background-color: ${theme.colors.neutral5};
                color: ${theme.colors.primary50};
              }
            `}
          >
            <Icon name={iconName} />
            <span>{title}</span>
          </NakedButton>
          <Tooltip {...tooltipProps}>{label}</Tooltip>
        </>
      )}
    </>
  );
};
